import {defineComponent, ref} from "vue";
import "./style/DistanceItem.scss"

export default defineComponent({
    name: "DistanceItem",
    props: {
        header: {type: Object},
        content: {type: Object},
        link: {type: Object},
        status: {type: String},
        index: ""
    },

    setup(props) {

        /**
         * title: "",
         * tag: {text:"",type:""}, default loading success danger warning
         * help: {show:false,callback:null},
         * link: {callback:null,show:false}
         * @returns {JSX.Element}
         */
        const createHeader = () => {
            let className = "text "
            let tag = null
            let linkClick = () => {}
            let help = null

            if (props.header.link && props.header.link.show) {
                className += "distance-item-list-link-header"
                linkClick = props.header.link.callback
            } else {
                className += "distance-item-list-header"
            }
            if (props.header.tag && props.header.tag.text !== "") {
                let tagClassName = "distance-item-list-tag distance-bg-color-" + (props.header.tag.type ? props.header.tag.type : "default")
                tag = <div className={tagClassName}>{props.header.tag.text}</div>
            }
            if (props.header.help && props.header.help.show) {
                help = creatHelp(props.header.help.callback)
            }

            return (
                <div className={className}>
                    <div onClick={linkClick}>
                        {props.header.title}
                    </div>
                    {tag}
                    {help}
                </div>
            )
        }

        /**
         * 创建内容
         * @returns {*[]}
         */
        const createContent = () => {
            let list = []
            let className = "distance-item-list-content text"
            if (props.content && props.content.list && props.content.list.length > 0) {
                for (let i = 0; i < props.content.list.length; i++) {
                    list.push(<div className={className}>{props.content.list[i]}</div>)
                }
            }
            return list
        }

        /**
         * 创建底部链接
         * @returns {JSX.Element}
         */
        const createLink = () => {
            let linkClick = props.link ? props.link.callback : () => {}
            if (props.link && props.link.text !== "") {
                return <div className={'distance-item-list-link text'} onClick={linkClick}>{props.link.text ? props.link.text + " >" : ""}</div>
            }
        }

        const html2Tip = ref('')
        /**
         * 创建help图标
         * @param callback
         * @returns {JSX.Element}
         */
        const creatHelp = (callback) => {

            let cb = callback ? callback : () => {}
            return (
                <div className={'distance-item-list-icon'} onClick={cb} onmouseenter={()=>helpShowTest('enter')} onmouseleave={()=>helpShowTest('leave')}>
                    <svg width="14" height="14" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24 44C29.5228 44 34.5228 41.7614 38.1421 38.1421C41.7614 34.5228 44 29.5228 44 24C44 18.4772 41.7614 13.4772 38.1421 9.85786C34.5228 6.23858 29.5228 4 24 4C18.4772 4 13.4772 6.23858 9.85786 9.85786C6.23858 13.4772 4 18.4772 4 24C4 29.5228 6.23858 34.5228 9.85786 38.1421C13.4772 41.7614 18.4772 44 24 44Z" fill="none" stroke="#0e42d2" stroke-width="4" stroke-linejoin="round"/>
                        <path d="M24 28.6248V24.6248C27.3137 24.6248 30 21.9385 30 18.6248C30 15.3111 27.3137 12.6248 24 12.6248C20.6863 12.6248 18 15.3111 18 18.6248" stroke="#0e42d2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24 37.6248C25.3807 37.6248 26.5 36.5055 26.5 35.1248C26.5 33.7441 25.3807 32.6248 24 32.6248C22.6193 32.6248 21.5 33.7441 21.5 35.1248C21.5 36.5055 22.6193 37.6248 24 37.6248Z" fill="#0e42d2"/>
                    </svg>
                    <div v-html={html2Tip.value} className={html2Tip.value ? `distance-item-list-help-text ${help_text_style}` : "distance-item-list-help-text-disabled"}>

                    </div>
                </div>
            )
        }
        let help_text_style = ''
        const helpShowTest = (en) =>{
          if(props.header.help.line === 'up'){
            help_text_style = 'distance-item-list-help-text-up'
          }else if(props.header.help.line === 'mid'){
            help_text_style = 'distance-item-list-help-text-mid'
          }else if(props.header.help.line === 'down'){
            help_text_style = 'distance-item-list-help-text-down'
          }else if(props.header.help.line === 'mid44'){
            help_text_style = 'distance-item-list-help-text-mid44'
          }else if(props.header.help.line === 'mid61'){
            help_text_style = 'distance-item-list-help-text-mid61'
          }
            if(props.header.help.text && en == 'enter'){
                html2Tip.value = props.header.help.text
            }else{
                html2Tip.value = ""
            }
        }

        // 创建卡片颜色
        const createCard = () => {
          let className = "distance-item-list"
          if (props.status && props.status === 'success') {
            className += " distance-item-list-green"
          }else if (props.status && props.status === 'warning') {
            className += " distance-item-list-yellow"
          }else if (props.status && props.status === 'loading') {
            className += " distance-item-list-blue"
          }else if (!props.status || props.status === 'default') {
            className += " distance-item-list-gray"
          }else if (!props.status || props.status === 'danger') {
            className += " distance-item-list-green"
          }
          return className
        }
        return () => (
            <div className={'distance-item'}>
                <div className={'distance-item-round distance-bg-color'} status={(props.status ? props.status : "default")}>
                    <svg width="12" height="12" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.9999 24V12M23.9999 24L13.5 30.0621L23.9999 24ZM23.9999 24L34.4998 30.0621L23.9999 24Z" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 16C14 18.2091 12.2091 20 10 20C7.79086 20 6 18.2091 6 16C6 13.7909 7.79086 12 10 12C12.2091 12 14 13.7909 14 16Z" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 32C14 34.2091 12.2091 36 10 36C7.79086 36 6 34.2091 6 32C6 29.7909 7.79086 28 10 28C12.2091 28 14 29.7909 14 32Z" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M28 40C28 42.2091 26.2091 44 24 44C21.7909 44 20 42.2091 20 40C20 37.7909 21.7909 36 24 36C26.2091 36 28 37.7909 28 40Z" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M42 32C42 34.2091 40.2091 36 38 36C35.7909 36 34 34.2091 34 32C34 29.7909 35.7909 28 38 28C40.2091 28 42 29.7909 42 32Z" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M42 16C42 18.2091 40.2091 20 38 20C35.7909 20 34 18.2091 34 16C34 13.7909 35.7909 12 38 12C40.2091 12 42 13.7909 42 16Z" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M28 8C28 10.2091 26.2091 12 24 12C21.7909 12 20 10.2091 20 8C20 5.79086 21.7909 4 24 4C26.2091 4 28 5.79086 28 8Z" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div className={createCard()}>
                    {createHeader()}
                    {createContent()}
                    {createLink()}
                </div>
            </div>
        )
    }
})
